<template>
    <div class="">
    <masternav/>
      <b-nav class="navlinks ">
        <b-nav-item router-link :to="{ name: 'Home'}">
          <span class="navtext ">{{$t('help.nav1')}}</span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item disabled>
            <span class="navtext2">Panel de usuario</span>
        </b-nav-item>
          <!-- <span class="mt-2 text-secondary">/</span>
        <b-nav-item >
          <span class="navtext">Another Link </span>
        </b-nav-item>
          <span class="mt-2 text-secondary">/</span>
        <b-nav-item >
            <span class="navtext">Disabled </span>
        </b-nav-item> -->
      </b-nav>
      <!-- <b-button @click="tab1=true, tab2=false">active 1</b-button>
      <b-button @click="tab2=true, tab1=false">active 2</b-button> -->
      <br><br>
           <div class="container"> 
             <div class="row">
               <div class="col-md-12">
                 <b-button  to="/" class="btnlinks float-right">{{$t('buttons_label.reserve_now')}} <!--RESERVAR AHORA--></b-button>
               </div>
             </div>
           </div>
      <div>
   
        <!-- <pre>{{history}}</pre> -->
        <b-tabs class="" content-class="mt-3" align="center" active-nav-item-class="border border-success">
          <b-tab :active="tab1">
            <template class="bg-dark" #title>
              <span class="navtext"><h5> Reservas activas </h5></span>
            </template>
            <div class="container-fluid">
             <b-row>
               <b-col md class="d-none d-sm-none d-md-block"></b-col>
               <b-col md="11">
                  <div style="border-top: solid 3px rgb(0, 0, 0) !important;">
                  <div v-if="load_spin==false">
                    <b-table 
                      class="d-none d-sm-none d-md-none d-lg-block"
                      ref="table"
                      striped
                      hover
                      sort-by="id"
                      :sort-desc="true"
                      responsive
                      :items="list_reserves"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      show-empty
                    >
                    <template #cell(auto)="row">
                      {{row.item.auto.marca}} {{row.item.auto.modelo}} 
                    </template>

                    <template #cell(coberturas)="row">
                      {{row.item.coberturas_id}}<span v-show="row.item.coberturas_obligatorias != ''">, {{ row.item.coberturas_obligatorias }}</span>
                    </template>

                    <template #cell(Check-In)="row">
                      <div v-if="row.item.checkin!=1">
                        <b-button 
                        squared 
                        variant="info" 
                        v-b-modal.check @click=" 
                        reserve_to_check = row.item.id, 
                        data.cond_adicional = row.item.conductor_adicional, 
                        data.name_arr = row.item.nombres, 
                        data.lastname_arr = row.item.apellido_paterno, 
                        data.id_arr = row.item.cedula, 
                        data.licencia_num = row.item.licencia_num, 
                        data.licencia_pais = row.item.licencia_pais, 
                        data.fecha_licencia = row.item.fecha_licencia, 
                        data.pais = row.item.pais, 
                        name_arr = row.item.nombres, 
                        lastname_arr = row.item.apellido_paterno, 
                        id_arr = row.item.cedula, 
                        data.ciudadTemp = row.item.usuario.ciudad,
                        data.barrioTemp = row.item.usuario.barrio,
                        data.calle_hotelTemp = row.item.usuario.calle,
                        data.casa_habTemp = row.item.usuario.casa,
                        data.telefonoTemp = row.item.usuario.telefono,
                        data.celularTemp = row.item.usuario.celular,
                        cond_adicional = row.item.conductor_adicional">
                            Check-In
                        </b-button>
                      </div>
                      <div v-else>
                        <!-- <h4 class="mt-1"><b-badge variant="success">Confirmada</b-badge></h4> -->
                        <b-button disabled squared variant="success">Confirmada
                          <b-spinner v-if="load_spin" small label="Small Spinner"></b-spinner>
                        </b-button>
                      </div>
                    </template>

                    <template #cell(Editar)="row">

                      <b-button
                      v-if="row.item.checkin!=1"
                                squared
                                variant="warning"
                                @click="cargaReservaEdit({num_reserva: row.item.id, brand: row.item.brand}),reset()">
                                Editar
                      </b-button>
                    </template>

                    </b-table>
                    <!-- stacked table for mobile -->
                    <b-table 
                      v-if="load_spin==false"
                      class="d-lg-none d-xl-none"
                      ref="table"
                      striped
                      hover
                      responsive
                      :items="list_reserves"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      show-empty
                      stacked>
                      <template #cell(auto)="row">
                      {{row.item.auto.marca}} {{row.item.auto.modelo}} 
                    </template>

                    <template #cell(Check-In)="row">
                      <div v-if="row.item.checkin!=1">
                        <b-button squared variant="info" v-b-modal.check @click="reserve_to_check = row.item.id, data.cond_adicional = row.item.conductor_adicional, data.name_arr = row.item.nombres, data.lastname_arr = row.item.apellido_paterno, data.id_arr = row.item.cedula">Check-In
                          
                        </b-button>
                      </div>
                      <div v-else>
                        <!-- <h4 class="mt-1"><b-badge variant="success">Confirmada</b-badge></h4> -->
                        <b-button disabled squared variant="success">Confirmada
                          <b-spinner v-if="load_spin" small label="Small Spinner"></b-spinner>
                        </b-button>
                      </div>
                    </template>

                    <template #cell(Editar)="row">

                      <b-button
                      v-if="row.item.checkin!=1"
                                squared
                                variant="warning"
                                @click="cargaReservaEdit({num_reserva: row.item.id, brand: row.item.brand}),reset()">
                                Editar
                      </b-button>
                                
                    </template>
                    </b-table>
                  </div>
                  <div class="d-flex justify-content-center mb-3 p-3">
                      <b-spinner v-if="load_spin" variant="success" style="width: 5rem; height: 5rem;" label="Large Spinner"></b-spinner>
                    </div>
                    <!-- Info modal -->
                    <b-modal no-close-on-backdrop size="xl" id="check" :title="'Check-In de reserva No. '+ reserve_to_check">
                      <!-- <pre>{{reserve_to_check}}</pre> -->
                      <!-- insert images -->
                    <b-form @submit="onSubmit">
                      <!-- <b-button squared size="lg" variant="danger" @click="reset()">
                        reset
                      </b-button> -->
                      <!-- datos arrendatario -->
                      <div>
                        <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                        <div class="pl-2 pr-2">
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Nombre</h2><b-form-input disabled v-model="name_arr" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Apellido</h2><b-form-input disabled v-model="lastname_arr" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Identificación</h2><b-form-input disabled v-model="id_arr" type="text"></b-form-input></b-col>
                        </b-row>
                        <br>
                        <b-row>
                          <b-col>
                            <b-form-checkbox v-model="checked" name="check-button" switch style="display:inline">
                                    <p style="text-decoration:none; padding:0px; margin-bottom: 15px; color: #169A5A; vertical-align:0; font-weight: bold;">
                                        Utilizar mi dirección en Panamá
                                    </p>
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col no-gutters cols="6" lg="4"><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad" type="text" :disabled="checked"></b-form-input></b-col>
                          <b-col no-gutters cols="6" lg="4"><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio" type="text" :disabled="checked"></b-form-input></b-col>
                          <b-col no-gutters cols="6" lg="4"><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel" type="text" :disabled="checked"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="6" lg="4"><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab" type="text" :disabled="checked"></b-form-input></b-col>
                          <b-col cols="6" lg="4"><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono" type="text" :disabled="checked"></b-form-input></b-col>
                          <b-col cols="6" lg="4"><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular" type="text" :disabled="checked"></b-form-input></b-col>
                        </b-row>
                        </div>
                         <br>
                         <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <div class="pl-2 pr-2">
                            </div>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-2 pl-5">Cédula o Pasaporte (Arrendatario)</h2>
                            </div>
                            <div class="text-center" v-if="Showced1.length > 0">
                              <img class="preview" :src="Showced1">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced1" required @change="previewCedArr" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-2 pl-5">Licencia (Arrendatario)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic1.length > 0">
                              <img class="preview" :src="Showlic1">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic1" required @change="previewLicArr" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                        <br><hr>
                      </div>
                      <!-- datos conductor adicional 1 -->
                      <div style="background:#e9ecef" class="bg-gray-200" v-if="cond_adicional>0">
                         <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Domicilio igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                          <div class="pl-2 pr-2">
                            <b-row>
                              <b-col><h2 class="titlesection pt-2 ">Nombre (Conductor 2)</h2><b-form-input required v-model="data.name_add2" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Apellido (Conductor 2)</h2><b-form-input required v-model="data.lastname_add2" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Identificación (Conductor 2)</h2><b-form-input required v-model="data.id_add2" type="text"></b-form-input></b-col>
                            </b-row>
                            <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad_c2" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio_c2" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel_c2" type="text"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab_c2" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono_c2" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular_c2" type="text"></b-form-input></b-col>
                        </b-row>
                          </div>
                          <br>
                        <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Cédula o Pasaporte (Conductor 2)</h2>
                            </div>
                            <div class="text-center" v-if="Showced2.length > 0">
                              <img class="preview" :src="Showced2">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced2" required @change="previewCedAdd2" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Licencia (Conductor 2)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic2.length > 0">
                              <img class="preview" :src="Showlic2">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic2" required @change="previewLicAdd2" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                        <br><hr>
                      </div>
                      <!-- datos conductor adicional 2 -->
                      <div v-if="cond_adicional>1">
                        <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Domicilio igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                        <div class="pl-2 pr-2">
                            <b-row>
                              <b-col><h2 class="titlesection pt-2 ">Nombre (Conductor 3)</h2><b-form-input required v-model="data.name_add3" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Apellido (Conductor 3)</h2><b-form-input required v-model="data.lastname_add3" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Identificación (Conductor 3)</h2><b-form-input required v-model="data.id_add3" type="text"></b-form-input></b-col>
                            </b-row>
                            <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad_c3" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio_c3" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel_c3" type="text"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab_c3" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono_c3" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular_c3" type="text"></b-form-input></b-col>
                        </b-row>
                          </div>
                          <br>
                        <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Cédula o Pasaporte (Conductor 3)</h2>
                            </div>
                            <div class="text-center" v-if="Showced3.length > 0">
                              <img class="preview" :src="Showced3">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced3" required @change="previewCedAdd3" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Licencia (Conductor 3)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic3.length > 0">
                              <img class="preview" :src="Showlic3">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic3" required @change="previewLicAdd3" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                        <br><hr>
                      </div>
                      <!-- datos conductor adicional 3 -->
                      <div style="background:#e9ecef" v-if="cond_adicional>2">
                        <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Domicilio igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                        <div class="pl-2 pr-2">
                            <b-row>
                              <b-col><h2 class="titlesection pt-2 ">Nombre (Conductor 4)</h2><b-form-input required v-model="data.name_add4" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Apellido (Conductor 4)</h2><b-form-input required v-model="data.lastname_add4" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Identificación (Conductor 4)</h2><b-form-input required v-model="data.id_add4" type="text"></b-form-input></b-col>
                            </b-row>
                            <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad_c4" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio_c4" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel_c4" type="text"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab_c4" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono_c4" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular_c4" type="text"></b-form-input></b-col>
                        </b-row>
                          </div>
                          <br>
                         <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Cédula o Pasaporte (Conductor 4)</h2>
                            </div>
                            <div class="text-center" v-if="Showced4.length > 0">
                              <img class="preview" :src="Showced4">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced4" required @change="previewCedAdd4" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Licencia (Conductor 4)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic4.length > 0">
                              <img class="preview" :src="Showlic4">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic4" required @change="previewLicAdd4" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                      <br><hr>
                      </div>
                      <!-- datos conductor adicional 4 -->
                      <div v-if="cond_adicional>3">
                        <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Domicilio igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                        <div class="pl-2 pr-2">
                            <b-row>
                              <b-col><h2 class="titlesection pt-2 ">Nombre (Conductor 5)</h2><b-form-input required v-model="data.name_add5" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Apellido (Conductor 5)</h2><b-form-input required v-model="data.lastname_add5" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Identificación (Conductor 5)</h2><b-form-input required v-model="data.id_add5" type="text"></b-form-input></b-col>
                            </b-row>
                            <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad_c5" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio_c5" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel_c5" type="text"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab_c5" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono_c5" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular_c5" type="text"></b-form-input></b-col>
                        </b-row>
                          </div>
                          <br>
                         <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Cédula o Pasaporte (Conductor 5)</h2>
                            </div>
                            <div class="text-center" v-if="Showced5.length > 0">
                              <img class="preview" :src="Showced5">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced5" required @change="previewCedAdd5" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Licencia (Conductor 5)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic5.length > 0">
                              <img class="preview" :src="Showlic5">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic5" required @change="previewLicAdd5" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                      <!--  -->
                      <br>
                      <div class="pt-5 text-center">
                        <b-button squared size="lg" type="submit" variant="success" ref="btnConfirm">CONFIRMAR CHECK-IN</b-button>
                      </div>
                    </b-form>
                    <template #modal-footer="{ cancel }">
                      <b-button squared size="lg" variant="danger" @click="reset(),cancel()">
                        CANCELAR
                      </b-button>
                    </template>
                    </b-modal>
                    <!-- paginacion -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="center"
                      size="lg"
                      class="my-0"
                    ></b-pagination>
                    <br><br>
                    <!-- <pre>{{list_reserves}}</pre> -->
                  </div>
               </b-col>
               <b-col md class="d-none d-sm-none d-md-block"></b-col>
             </b-row>
            </div> 
          </b-tab>
          <!-- tab 2 -->
          <b-tab :active="tab2">
            <template class="" #title>
              <span class="navtext"><h5> Historial </h5></span>
            </template>
            <b-row>
               <b-col md class="d-none d-sm-none d-md-block"></b-col>
               <b-col md="11">
                  <div style="border-top: solid 3px rgb(0, 0, 0) !important;">
                    <b-table 
                      v-if="load_spin_hist==false"
                      striped 
                      hover 
                      :items="history"
                      responsive
                      :current-page="currentPage2"
                      :per-page="perPage2"
                      show-empty
                    >
                    <!-- down_contract, down_invoice -->
                    
                    <template #cell(Factura)="row">
                      <b-link v-show="row.item.Factura != 0" @click="down_invoice(row.item.Factura)">{{row.item.Factura}}</b-link>
                    </template>
                    
                    <template #cell(Contrato)="row">
                      <b-link @click="down_contract(row.item.Contrato)">{{row.item.Contrato}}</b-link>
                    </template>

                    <template #cell(Reserva)="row">
                      <p v-show="row.item.Reserva != 0">{{ row.item.Reserva }}</p>
                    </template>

                    </b-table>
                  </div>
                  <div class="d-flex justify-content-center mb-3 p-3">
                      <b-spinner v-if="load_spin_hist" variant="success" style="width: 5rem; height: 5rem;" label="Large Spinner"></b-spinner>
                    </div>
                    <!-- paginacion historial -->
                    <b-pagination
                      v-model="currentPage2"
                      :total-rows="totalRows2"
                      :per-page="perPage2"
                      align="center"
                      size="lg"
                      class="my-0"
                    ></b-pagination>
                    <br><br>
               </b-col>
               <b-col md class="d-none d-sm-none d-md-block"></b-col>
             </b-row>
          </b-tab>
          <!-- tab 3 -->
          <b-tab :active="tab3">
            <template class="bg-dark" #title>
              <span class="navtext"><h5> Reservas Anuladas/Caducadas </h5></span>
            </template>
            <div class="container-fluid">
             <b-row>
               <b-col md class="d-none d-sm-none d-md-block"></b-col>
               <b-col md="11">
                  <div style="border-top: solid 3px rgb(0, 0, 0) !important;">
                  <div v-if="load_spin==false">
                    <b-table 
                      class="d-none d-sm-none d-md-none d-lg-block"
                      ref="table"
                      striped
                      hover
                      sort-by="id"
                      :sort-desc="true"
                      responsive
                      :items="list_reserves_cancel"
                      :fields="fields2"
                      :current-page="currentPage"
                      :per-page="perPage"
                      show-empty
                    >
                    <template #cell(auto)="row">
                      {{row.item.auto.marca}} {{row.item.auto.modelo}} 
                    </template>

                    <template #cell(coberturas)="row">
                      {{row.item.coberturas_id}}<span v-show="row.item.coberturas_obligatorias != ''">, {{ row.item.coberturas_obligatorias }}</span>
                    </template>

                    </b-table>
                    <!-- stacked table for mobile -->
                    <b-table 
                      v-if="load_spin==false"
                      class="d-lg-none d-xl-none"
                      ref="table"
                      striped
                      hover
                      responsive
                      :items="list_reserves"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      show-empty
                      stacked>
                      <template #cell(auto)="row">
                      {{row.item.auto.marca}} {{row.item.auto.modelo}} 
                    </template>

                    </b-table>
                  </div>
                  <div class="d-flex justify-content-center mb-3 p-3">
                      <b-spinner v-if="load_spin" variant="success" style="width: 5rem; height: 5rem;" label="Large Spinner"></b-spinner>
                    </div>
                    <!-- Info modal -->
                    <b-modal no-close-on-backdrop size="xl" id="check" :title="'Check-In de reserva No. '+ reserve_to_check">
                      <!-- <pre>{{reserve_to_check}}</pre> -->
                      <!-- insert images -->
                    <b-form @submit="onSubmit">
                      <!-- <b-button squared size="lg" variant="danger" @click="reset()">
                        reset
                      </b-button> -->
                      <!-- datos arrendatario -->
                      <div>
                        <b-row class="p-2">
                          <b-col></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                        <div class="pl-2 pr-2">
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Nombre</h2><b-form-input disabled v-model="name_arr" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Apellido</h2><b-form-input disabled v-model="lastname_arr" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Identificación</h2><b-form-input disabled v-model="id_arr" type="text"></b-form-input></b-col>
                        </b-row>
                        <br>
                        <b-row>
                          <b-col>
                            <div class="titlesection">Domicilio en Panamá:</div>
                            <b-form-checkbox v-model="checked" name="check-button" switch style="display:inline">
                                    <p style="text-decoration:none; padding:0px; margin-bottom: 15px; color: #169A5A; vertical-align:0; font-weight: bold;">
                                        Utilizar mi dirección en Panamá
                                    </p>
                            </b-form-checkbox>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col no-gutters cols="6" lg="4"><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad" type="text" :disabled="checked"></b-form-input></b-col>
                          <b-col no-gutters cols="6" lg="4"><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio" type="text" :disabled="checked"></b-form-input></b-col>
                          <b-col no-gutters cols="6" lg="4"><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel" type="text" :disabled="checked"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="6" lg="4"><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab" type="text" :disabled="checked"></b-form-input></b-col>
                          <b-col cols="6" lg="4"><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono" type="text" :disabled="checked"></b-form-input></b-col>
                          <b-col cols="6" lg="4"><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular" type="text" :disabled="checked"></b-form-input></b-col>
                        </b-row>
                        </div>
                         <br>
                         <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <div class="pl-2 pr-2">
                            </div>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-2 pl-5">Cédula o Pasaporte (Arrendatario)</h2>
                            </div>
                            <div class="text-center" v-if="Showced1.length > 0">
                              <img class="preview" :src="Showced1">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced1" required @change="previewCedArr" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-2 pl-5">Licencia (Arrendatario)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic1.length > 0">
                              <img class="preview" :src="Showlic1">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic1" required @change="previewLicArr" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                        <br><hr>
                      </div>
                      <!-- datos conductor adicional 1 -->
                      <div style="background:#e9ecef" class="bg-gray-200" v-if="cond_adicional>0">
                         <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Domicilio igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                          <div class="pl-2 pr-2">
                            <b-row>
                              <b-col><h2 class="titlesection pt-2 ">Nombre (Conductor 2)</h2><b-form-input required v-model="data.name_add2" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Apellido (Conductor 2)</h2><b-form-input required v-model="data.lastname_add2" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Identificación (Conductor 2)</h2><b-form-input required v-model="data.id_add2" type="text"></b-form-input></b-col>
                            </b-row>
                            <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad_c2" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio_c2" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel_c2" type="text"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab_c2" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono_c2" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular_c2" type="text"></b-form-input></b-col>
                        </b-row>
                          </div>
                          <br>
                        <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Cédula o Pasaporte (Conductor 2)</h2>
                            </div>
                            <div class="text-center" v-if="Showced2.length > 0">
                              <img class="preview" :src="Showced2">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced2" required @change="previewCedAdd2" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Licencia (Conductor 2)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic2.length > 0">
                              <img class="preview" :src="Showlic2">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic2" required @change="previewLicAdd2" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                        <br><hr>
                      </div>
                      <!-- datos conductor adicional 2 -->
                      <div v-if="cond_adicional>1">
                        <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Domicilio igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                        <div class="pl-2 pr-2">
                            <b-row>
                              <b-col><h2 class="titlesection pt-2 ">Nombre (Conductor 3)</h2><b-form-input required v-model="data.name_add3" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Apellido (Conductor 3)</h2><b-form-input required v-model="data.lastname_add3" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Identificación (Conductor 3)</h2><b-form-input required v-model="data.id_add3" type="text"></b-form-input></b-col>
                            </b-row>
                            <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad_c3" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio_c3" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel_c3" type="text"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab_c3" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono_c3" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular_c3" type="text"></b-form-input></b-col>
                        </b-row>
                          </div>
                          <br>
                        <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Cédula o Pasaporte (Conductor 3)</h2>
                            </div>
                            <div class="text-center" v-if="Showced3.length > 0">
                              <img class="preview" :src="Showced3">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced3" required @change="previewCedAdd3" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Licencia (Conductor 3)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic3.length > 0">
                              <img class="preview" :src="Showlic3">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic3" required @change="previewLicAdd3" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                        <br><hr>
                      </div>
                      <!-- datos conductor adicional 3 -->
                      <div style="background:#e9ecef" v-if="cond_adicional>2">
                        <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Domicilio igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                        <div class="pl-2 pr-2">
                            <b-row>
                              <b-col><h2 class="titlesection pt-2 ">Nombre (Conductor 4)</h2><b-form-input required v-model="data.name_add4" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Apellido (Conductor 4)</h2><b-form-input required v-model="data.lastname_add4" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Identificación (Conductor 4)</h2><b-form-input required v-model="data.id_add4" type="text"></b-form-input></b-col>
                            </b-row>
                            <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad_c4" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio_c4" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel_c4" type="text"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab_c4" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono_c4" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular_c4" type="text"></b-form-input></b-col>
                        </b-row>
                          </div>
                          <br>
                         <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Cédula o Pasaporte (Conductor 4)</h2>
                            </div>
                            <div class="text-center" v-if="Showced4.length > 0">
                              <img class="preview" :src="Showced4">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced4" required @change="previewCedAdd4" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Licencia (Conductor 4)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic4.length > 0">
                              <img class="preview" :src="Showlic4">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic4" required @change="previewLicAdd4" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                      <br><hr>
                      </div>
                      <!-- datos conductor adicional 4 -->
                      <div v-if="cond_adicional>3">
                        <b-row class="p-2">
                          <b-col><div class="titlesection">Domicilio en Panamá:</div></b-col>
                          <!-- <b-col>
                            <label class="customcheck"><span class="titlesection">Domicilio igual al arrendatario.</span> 
                              <input type="checkbox" v-model="selected" value="Autos" checked="checked">
                              <span class="checkmark"></span>
                            </label>
                          </b-col> -->
                        </b-row>
                        <div class="pl-2 pr-2">
                            <b-row>
                              <b-col><h2 class="titlesection pt-2 ">Nombre (Conductor 5)</h2><b-form-input required v-model="data.name_add5" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Apellido (Conductor 5)</h2><b-form-input required v-model="data.lastname_add5" type="text"></b-form-input></b-col>
                              <b-col><h2 class="titlesection pt-2 ">Identificación (Conductor 5)</h2><b-form-input required v-model="data.id_add5" type="text"></b-form-input></b-col>
                            </b-row>
                            <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Ciudad</h2><b-form-input required v-model="data.ciudad_c5" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Barrio</h2><b-form-input required v-model="data.barrio_c5" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Calle/Hotel</h2><b-form-input required v-model="data.calle_hotel_c5" type="text"></b-form-input></b-col>
                        </b-row>
                        <b-row>
                          <b-col><h2 class="titlesection pt-2 ">Casa/Hab</h2><b-form-input required v-model="data.casa_hab_c5" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Teléfono</h2><b-form-input required v-model="data.telefono_c5" type="text"></b-form-input></b-col>
                          <b-col><h2 class="titlesection pt-2 ">Celular</h2><b-form-input required v-model="data.celular_c5" type="text"></b-form-input></b-col>
                        </b-row>
                          </div>
                          <br>
                         <div class="titlesection p-2">Documentos requeridos:</div>
                        <b-row>
                          <b-col>
                            <!-- cedula -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Cédula o Pasaporte (Conductor 5)</h2>
                            </div>
                            <div class="text-center" v-if="Showced5.length > 0">
                              <img class="preview" :src="Showced5">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="ced5" required @change="previewCedAdd5" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                          <b-col>
                            <!-- licencia -->
                            <div class="">
                                <h2 class="titlesection pt-4 pl-5">Licencia (Conductor 5)</h2>
                            </div>
                            <div class="text-center" v-if="Showlic5.length > 0">
                              <img class="preview" :src="Showlic5">
                            </div>
                            <br>
                            <div class="text-center">
                              <input type="file" id="lic5" required @change="previewLicAdd5" accept=".jpg, .png, .jpeg, .pdf">
                            </div>
                          </b-col>
                        </b-row>
                      </div>
                      <!--  -->
                      <br>
                      <div class="pt-5 text-center">
                        <b-button squared size="lg" type="submit" variant="success" ref="btnConfirm">CONFIRMAR CHECK-IN</b-button>
                      </div>
                    </b-form>
                    <template #modal-footer="{ cancel }">
                      <b-button squared size="lg" variant="danger" @click="reset(),cancel()">
                        CANCELAR
                      </b-button>
                    </template>
                    </b-modal>
                    <!-- paginacion -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="center"
                      size="lg"
                      class="my-0"
                    ></b-pagination>
                    <br><br>
                    <!-- <pre>{{list_reserves}}</pre> -->
                  </div>
               </b-col>
               <b-col md class="d-none d-sm-none d-md-block"></b-col>
             </b-row>
            </div> 
          </b-tab>
        </b-tabs>
      </div>
    <mainfooter/>
    </div>
</template>
<script>
import masternav      from '@/components/masternav.vue'
import maincontent    from '@/components/maincontent.vue'
import mainfooter     from '@/components/mainfooter.vue'
import rents          from '@/components/rents.vue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

export default {
    name: 'Panel',
    components:{
        masternav,
        mainfooter,
        maincontent,
        rents
    },
    data() {
      return {
        checked:false,
        load_spin: true,
        load_spin_hist: true,
        reservas_logged:[],

        ced1:'', ced2:'', ced3:'', ced4:'', ced5:'',
        lic1:'', lic2:'', lic3:'', lic4:'', lic5:'',
        Showced1:'', Showced2:'', Showced3:'', Showced4:'', Showced5:'',
        Showlic1:'', Showlic2:'', Showlic3:'', Showlic4:'', Showlic5:'',
        
      hist: {id:''},
      data: {
        name_arr:'',
        lastname_arr:'',
        id_arr:'',
      
        cedula_arr:'',
        licencia_arr:'',

        cedula_add2:'',
        licencia_add2:'',
        
        cedula_add3:'',
        licencia_add3:'',
        
        cedula_add4:'',
        licencia_add4:'',
        
        cedula_add5:'',
        licencia_add5:'',
        
        /* datos adicionales */
        licencia_num: '',
        licencia_pais: '',
        fecha_licencia: '',
        pais: '',
        cond_adicional:'',
      },
      //para mostrar solamente
        name_arr:'',
        lastname_arr:'',
        id_arr:'',
        cond_adicional:'',
      //******************* */
        tab1: true,
        tab2: false,
        tab3:false,
        reserve_to_check: '',

        totalRows: 1,
        currentPage: 1,
        perPage: 5,

        totalRows2: 1,
        currentPage2: 1,
        perPage2: 5,

        fields: [
          { label: 'No.Reserva',      key: 'id',                sortable: true ,  class: 'text-center'},
          { label: 'Fecha de retiro', key: 'fecha_salida',      sortable: true ,  class: 'text-center'},
          { label: 'Auto',            key: 'auto',              sortable: false , class: 'text-center'},
          { label: 'Sucursal',        key: 'retiro.nombre_web', sortable: false , class: 'text-center'},
          { label: 'Coberturas',      key: 'coberturas',        sortable: false , class: 'text-center'},
          { label: 'Check-In',        key: 'Check-In',          sortable: false , class: 'text-center'},
          { label: 'Editar',          key: 'Editar',            sortable: false , class: 'text-center'},
        ],
        fields2: [
          { label: 'No.Reserva',              key: 'id',                sortable: true ,  class: 'text-center'},
          { label: 'Fecha Anulada/Caducada',  key: 'fecha_salida',      sortable: true ,  class: 'text-center'},
          { label: 'Auto',                    key: 'auto',              sortable: false , class: 'text-center'},
          { label: 'Sucursal',                key: 'retiro.nombre_web', sortable: false , class: 'text-center'},
          { label: 'Coberturas',              key: 'coberturas',        sortable: false , class: 'text-center'},
        ],
        items: [
          { isActive: true,  reserva: 1001, first_name: 'Dickerson', last_name: 'Macdonald' },
          { isActive: false, reserva: 1002, first_name: 'Larsen',    last_name: 'Shaw' },
          { isActive: false, reserva: 1003, first_name: 'Geneva',    last_name: 'Wilson' },
          { isActive: true,  reserva: 1004, first_name: 'Dickerson', last_name: 'Macdonald' },
          { isActive: false, reserva: 1005, first_name: 'Larsen',    last_name: 'Shaw' },
          { isActive: false, reserva: 1006, first_name: 'Geneva',    last_name: 'Wilson' },
          { isActive: true,  reserva: 1007, first_name: 'Dickerson', last_name: 'Macdonald' },
          { isActive: false, reserva: 1008, first_name: 'Larsen',    last_name: 'Shaw' },
          { isActive: false, reserva: 1009, first_name: 'Geneva',    last_name: 'Wilson' },
          { isActive: true,  reserva: 1010, first_name: 'Jami',      last_name: 'Carney' }
        ]
      }
    },
    mounted() {
      this.totalRows = this.items.length
      this.get_reserves()
      //this.gett_user()
      //this.hist.id = this.gett_user()
      //console.log(this.hist.id)
      this.historial()
    },
    watch: {
      checked(){
        if(this.checked){
          this.data.ciudad = this.data.ciudadTemp
          this.data.barrio = this.data.barrioTemp 
          this.data.calle_hotel = this.data.calle_hotelTemp 
          this.data.casa_hab = this.data.casa_habTemp 
          this.data.telefono = this.data.telefonoTemp 
          this.data.celular = this.data.celularTemp 
        }else{
          this.data.ciudad = ""
          this.data.barrio = ""
          this.data.calle_hotel = ""
          this.data.casa_hab = ""
          this.data.telefono = ""
          this.data.celular = "" 
        }
      },
      list_reserves: function(val, oldval){
        if(val!=oldval){
         this.load_spin = !this.load_spin
        }
      },
      history: function(val, oldval){
        if(val!=oldval){
         this.load_spin_hist = !this.load_spin_hist
        }
      },
      ced1: function(val, oldval){
        if(val!=null){
          this.Showced1 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('cedula', val); */
          this.data.cedula_arr = val
        }
      },
      ced2: function(val, oldval){
        if(val!=null){
          this.Showced2 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('cedula', val); */
          this.data.cedula_add2 = val
        }
      },
      ced3: function(val, oldval){
        if(val!=null){
          this.Showced3 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('cedula', val); */
          this.data.cedula_add3 = val
        }
      },
      ced3: function(val, oldval){
        if(val!=null){
          this.Showced3 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('cedula', val); */
          this.data.cedula_add3 = val
        }
      },
      ced4: function(val, oldval){
        if(val!=null){
          this.Showced4 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('cedula', val); */
          this.data.cedula_add4 = val
        }
      },
      ced5: function(val, oldval){
        if(val!=null){
          this.Showced5 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('cedula', val); */
          this.data.cedula_add5 = val
        }
      },

      lic1: function(val, oldval){
        if(val!=null){
          this.Showlic1 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('licencia', val); */
          this.data.licencia_arr = val
        }
      },
      lic2: function(val, oldval){
        if(val!=null){
          this.Showlic2 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('licencia', val); */
          this.data.licencia_add2 = val
        }
      },
      lic3: function(val, oldval){
        if(val!=null){
          this.Showlic3 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('licencia', val); */
          this.data.licencia_add3 = val
        }
      },
      lic4: function(val, oldval){
        if(val!=null){
          this.Showlic4 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('licencia', val); */
          this.data.licencia_add4 = val
        }
      },
      lic5: function(val, oldval){
        if(val!=null){
          this.Showlic5 = URL.createObjectURL(val);
          /* let formData = new FormData();
          formData.append('licencia', val); */
          this.data.licencia_add5 = val
        }
      },

    },
    computed: {
      ...mapState('reserva', ['list_reserves', 'list_reserves_cancel']),
      ...mapGetters('autenticacion',['gett_user']),
      ...mapGetters('reserva',['history'])
    },
    methods: {
      ...mapActions('reserva', ['get_reserves','check_in','historial', 'down_contract', 'down_invoice']),
      ...mapActions('reservav2', ['cargaReservaEdit']),
       onSubmit(event) {
        event.preventDefault()
        //alert(JSON.stringify(this.form))
        this.load_spin = true
        //this.check_in({id: this.reserve_to_check, json_detalle_checkin: this.data})
        //this.get_reserves()
        //alert('¡Check-in confirmado!')
        this.sendForm()
        //console.log(this.reserve_to_check, this.data)
        //this.reset()
        this.$root.$emit('bv::hide::modal', 'check', '#btnConfirm')//
        //this.$refs.table.refresh();
      },
      sendForm(){
        let formData = new FormData();
          formData.append('reserve_to_check',this.reserve_to_check)
          formData.append('licencia_num',    this.data.licencia_num)
          formData.append('licencia_pais',   this.data.licencia_pais)
          formData.append('fecha_licencia',  this.data.fecha_licencia)
          formData.append('pais',            this.data.pais)
          formData.append('cond_adicional',  this.data.cond_adicional)

        //-------------------------Arrendatario------------------------------
          formData.append('name_arr',        this.data.name_arr)
          formData.append('lastname_arr',    this.data.lastname_arr)
          formData.append('id_arr',          this.data.id_arr)
          
          formData.append('ciudad',          this.data.ciudad)
          formData.append('barrio',          this.data.barrio)
          formData.append('calle_hotel',     this.data.calle_hotel)
          formData.append('casa_hab',        this.data.casa_hab)
          formData.append('telefono',        this.data.telefono)
          formData.append('celular',         this.data.celular)

          formData.append('cedula_arr',      this.data.cedula_arr)
          formData.append('licencia_arr',    this.data.licencia_arr)
        //------------------------------------------------------------------

        //-------------------------Cond Adicional 2-------------------------
          formData.append('name_add2',       this.data.name_add2)
          formData.append('lastname_add2',   this.data.lastname_add2)
          formData.append('id_add2',         this.data.id_add2)

          formData.append('ciudad_c2',       this.data.ciudad_c2)
          formData.append('barrio_c2',       this.data.barrio_c2)
          formData.append('calle_hotel_c2',  this.data.calle_hotel_c2)
          formData.append('casa_hab_c2',     this.data.casa_hab_c2)
          formData.append('telefono_c2',     this.data.telefono_c2)
          formData.append('celular_c2',      this.data.celular_c2)
          
          formData.append('cedula_add2',     this.data.cedula_add2)
          formData.append('licencia_add2',   this.data.licencia_add2)
        //------------------------------------------------------------------

        //-------------------------Cond Adicional 3-------------------------
          formData.append('name_add3',       this.data.name_add3)
          formData.append('lastname_add3',   this.data.lastname_add3)
          formData.append('id_add3',         this.data.id_add3)

          formData.append('ciudad_c3',       this.data.ciudad_c3)
          formData.append('barrio_c3',       this.data.barrio_c3)
          formData.append('calle_hotel_c3',  this.data.calle_hotel_c3)
          formData.append('casa_hab_c3',     this.data.casa_hab_c3)
          formData.append('telefono_c3',     this.data.telefono_c3)
          formData.append('celular_c3',      this.data.celular_c3)
          
          formData.append('cedula_add3',     this.data.cedula_add3)
          formData.append('licencia_add3',   this.data.licencia_add3)
        //------------------------------------------------------------------

        //-------------------------Cond Adicional 4-------------------------
          formData.append('name_add4',       this.data.name_add4)
          formData.append('lastname_add4',   this.data.lastname_add4)
          formData.append('id_add4',         this.data.id_add4)

          formData.append('ciudad_c4',       this.data.ciudad_c4)
          formData.append('barrio_c4',       this.data.barrio_c4)
          formData.append('calle_hotel_c4',  this.data.calle_hotel_c4)
          formData.append('casa_hab_c4',     this.data.casa_hab_c4)
          formData.append('telefono_c4',     this.data.telefono_c4)
          formData.append('celular_c4',      this.data.celular_c4)
          
          formData.append('cedula_add4',     this.data.cedula_add4)
          formData.append('licencia_add4',   this.data.licencia_add4)
        //------------------------------------------------------------------

        //-------------------------Cond Adicional 5-------------------------
          formData.append('name_add5',       this.data.name_add5)
          formData.append('lastname_add5',   this.data.lastname_add5)
          formData.append('id_add5',         this.data.id_add5)

          formData.append('ciudad_c5',       this.data.ciudad_c5)
          formData.append('barrio_c5',       this.data.barrio_c5)
          formData.append('calle_hotel_c5',  this.data.calle_hotel_c5)
          formData.append('casa_hab_c5',     this.data.casa_hab_c5)
          formData.append('telefono_c5',     this.data.telefono_c5)
          formData.append('celular_c5',      this.data.celular_c5)
          
          formData.append('cedula_add5',     this.data.cedula_add5)
          formData.append('licencia_add5',   this.data.licencia_add5)
        //------------------------------------------------------------------

        this.check_in(formData)
      },
      refresh(){
        this.get_reserves()
        this.$refs.table.refresh();
      },
      reset(){
        this.data = {}
        this.checked = false
        this.Showced1='', this.Showced2='', this.Showced3='', this.Showced4='', this.Showced5='',
        this.Showlic1='', this.Showlic2='', this.Showlic3='', this.Showlic4='', this.Showlic5=''
        //this.reservas_logged=[],
        //this.data.cond_adicional=''
       
      },
      previewCedArr: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'ced1'
        let show = 'Showced1'
        this.validarSizeFile(files, file, show)
      },
      previewLicArr: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'lic1'
        let show = 'Showlic1'
        this.validarSizeFile(files, file, show)
      },
      previewCedAdd2: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'ced2'
        let show = 'Showced2'
        this.validarSizeFile(files, file, show)
      },
      previewLicAdd2: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'lic2'
        let show = 'Showlic2'
        this.validarSizeFile(files, file, show)
      },
      previewCedAdd3: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'ced3'
        let show = 'Showced3'
        this.validarSizeFile(files, file, show)
      },
      previewLicAdd3: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'lic3'
        let show = 'Showlic3'
        this.validarSizeFile(files, file, show)
      },
      previewCedAdd4: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'ced4'
        let show = 'Showced4'
        this.validarSizeFile(files, file, show)
      },
      previewLicAdd4: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'lic4'
        let show = 'Showlic4'
        this.validarSizeFile(files, file, show)
      },
      previewCedAdd5: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'ced5'
        let show = 'Showced5'
        this.validarSizeFile(files, file, show)
      },
      previewLicAdd5: function(event) {
        var files = event.target.files || event.dataTransfer.files;
        let file = 'lic5'
        let show = 'Showlic5'
        this.validarSizeFile(files, file, show)
      },
      validarSizeFile(files, file, show){

        if(files[0].size > 1000000) {
          this.$bvToast.toast('El archivo sobrepasa la capacidad de tamaño',{
              title: 'Alerta',
              variant: 'danger',
              toaster: 'b-toaster-bottom-center',
              solid: true
              })
            document.getElementById(file).value= null;

            switch (show) {
              case 'Showced1':
                this.Showced1 = ''
                break;
              case 'Showlic1':
                this.Showlic1 = ''
                break;
              case 'Showced2':
                this.Showced2 = ''
                break;
              case 'Showlic2':
                this.Showlic2 = ''
                break;
              case 'Showced3':
                this.Showced3 = ''
                break;
              case 'Showlic3':
                this.Showlic3 = ''
                break;
              case 'Showced4':
                this.Showced4 = ''
                break;
              case 'Showlic4':
                this.Showlic4 = ''
                break;
              case 'Showced5':
                this.Showced5 = ''
                break;
              case 'Showlic5':
                this.Showlic5 = ''
                break;
            }
        }else{

          switch (file) {
            case 'ced1':
              this.ced1 = files[0]
              break;
            case 'lic1':
              this.lic1 = files[0]
              break;
            case 'ced2':
              this.ced2 = files[0]
              break;
            case 'lic2':
              this.lic2 = files[0]
              break;
            case 'ced3':
              this.ced3 = files[0]
              break;
            case 'lic3':
              this.lic3 = files[0]
              break;
            case 'ced4':
              this.ced4 = files[0]
              break;
            case 'lic4':
              this.lic4 = files[0]
              break;
            case 'ced5':
              this.ced5 = files[0]
              break;
            case 'lic5':
              this.lic5 = files[0]
              break;
          }
        }
      }
      
  },
}
</script>
<style  scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
@media (min-width: 992px) {
  .modal-dialog {
    max-width: 80%;
  }
}
.b-modal{
  width: 90% !important;
}
img.preview {
    width: 300px;
    height: 200px;
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}
input[type="file"]::-webkit-file-upload-button{
   /* style goes here */
  font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
  color: #FFFFFF;
  size: 14px;
  letter-spacing: 0.9px;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  background: #169A5A;
  height: 33px;
  border: 1px solid green !important;
  cursor: pointer;
}
input[type="file"]::-webkit-file-upload-button:hover {
  background-color: #006639;
}
input[type="file"]::-webkit-file-upload-button:focus {
  outline: 2px solid #a4ceff !important;
}
input[type="file"]{
  border: solid 1px #169a5a;
}
.wrapper {
    min-height: 100%;
    height: auto !important;
    margin: 0 auto -30px;
    padding: 0 0 30px 0px;   /* new padding */
}
.collapsing {
  transition: none !important;
}
.titlesection{
  font-family: 'DIN 2014-Regular', Arial, sans-serif;
   font-size: 18px;
   color: #333333;
   font-weight: 600;
   margin-bottom: 15px;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.questions{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: 32px;
    line-height: 40px;
    color: #169a5a;
    font-size: 17px;
    font-weight: 500;
    text-decoration: none;
    margin: 0px;
    padding: 0px;
}
.questions:hover {
  color: #006639 !important;
}
.questions:focus {
  outline: 2px solid #a4ceff !important;
}
.navlinks{
    border-bottom: solid 0.05px rgb(185, 185, 185);
    
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14px;
    font-weight: 300;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}


/* /////////// CHECKBOX //////////////  */
/* The customcheck */
.customcheck {
    display: block;
    position: relative;
    padding-left: 35px;
    padding-top: 5px;
    margin-bottom: 22px;
    font-size: 14px;
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    margin-left: -14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* Hide the browser's default checkbox */
.customcheck input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* Create a custom checkbox */
.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 28px;
    width:  28px;
    background-color: rgb(255, 255, 255);
    border-radius: 0px;
    border: solid 2px #b8b8b8;
}

/* On mouse-over, add a grey background color */
.customcheck:hover input ~ .checkmark {
    background-color: #eee;
}

/* When the checkbox is checked, add a blue background */
.customcheck input:checked ~ .checkmark {
    background-color: #ffffff;
    border-radius: 0px;
    border: solid 3px #169a5a;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

/* Show the checkmark when checked */
.customcheck input:checked ~ .checkmark:after {
    display: block;
}

/* Style the checkmark/indicator */
.customcheck .checkmark:after {
    left: 6px;
    top: 3px;
    width: 10px;
    height: 12px;
    border: solid 2px #169a5a;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
}
.btnlinks{
  font-family: 'DIN 2014-ExraBold', 'Arial Black', Arial, sans-serif;
  background-color: #169A5A;
  border: 0px;
  border-radius: 0px;
  font-weight: 900;
  font-size: 15px;
}

</style>